<ukg-card has-border non-actionable class="panel-container flex-fill flex-column">
  <div class="panel-heading psg-heading-row" [class.heading-row]="true">
    <div class="flex-row flex-gap-10">
      <div class="flex-1-0">
        <span class="filter-title" translate>
          AT_A_GLANCE.PANEL_TITLE
        </span>
      </div>
      <div *ngIf="false">  <!-- Temporarily removing but it will be back in the future -->
        <div ngbDropdown>
          <a ngbDropdownToggle id="dropdownMenu1">
            <i class="panel-heading-button fa fa-align-left"></i>
          </a>
          <div ngbDropdownMenu aria-labelledby="dropdownMenu1">
            <button class="dropdown-item" data-automation="at-a-glance-expand-all" (click)="allExpanded = true" translate>COMMON.EXPAND_ALL</button>
            <button class="dropdown-item" data-automation="at-a-glance-collapse-all" (click)="allExpanded = false" translate>COMMON.COLLAPSE_ALL</button>
          </div>
        </div>
      </div>
      <div *ngIf="false"> <!-- Temporarily removing but it will be back in the future -->
        <div ngbDropdown>
          <a ngbDropdownToggle class="panel-heading-button" id="dropdownMenu2">
            <i class="fa fa-cog"></i>
          </a>
          <div ngbDropdownMenu aria-labelledby="dropdownMenu2">
            <button class="dropdown-item" data-automation="at-a-glance-manage-hierarchy" translate>COMMON.MANAGE_HIERARCHY</button>
            <button class="dropdown-item" data-automation="at-a-glance-display-options" translate>COMMON.DISPLAY_OPTIONS</button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="heading-row filters-placeholder psg-heading-row">&nbsp;</div>
  <ukg-card-content class="at-a-glance-body">
    <div>
    <ssg-vertical-progress-map>
      <ssg-vertical-progress-step [usePsgStyle]="true" [complete]="progressStates.get('payroll').complete" [inProgress]="progressStates.get('payroll').inProgress">
        <ssg-at-a-glance-payroll [allExpanded]="allExpanded" (progressStatesChanged)="updateProgressStates('payroll', $event)"></ssg-at-a-glance-payroll>
      </ssg-vertical-progress-step>
      <ssg-vertical-progress-step [usePsgStyle]="true" [complete]="progressStates.get('collections').complete" [inProgress]="progressStates.get('collections').inProgress">
        <ssg-at-a-glance-collections [allExpanded]="allExpanded" (progressStatesChanged)="updateProgressStates('collections', $event)"></ssg-at-a-glance-collections>
      </ssg-vertical-progress-step>
      <ssg-vertical-progress-step [usePsgStyle]="true" [complete]="progressStates.get('payment').complete" [inProgress]="progressStates.get('payment').inProgress">
          <ssg-at-a-glance-payments (progressStatesChanged)="updateProgressStates('payment', $event)"></ssg-at-a-glance-payments>
      </ssg-vertical-progress-step>
    </ssg-vertical-progress-map>
  </div>
  </ukg-card-content>
  <!-- <div class="filters-cover" (click)="filtersControl.cancelEdits()" [hidden]="!filtersControl || !filtersControl.isEditing">&nbsp;</div> -->
  <div class="heading-row filters-row psg-heading-row filter-content-width">
    <ssg-filters></ssg-filters>
  </div>
</ukg-card>